// extracted by mini-css-extract-plugin
export default {"Form":"LoginForm_Form__Wfj5N","FormLink":"LoginForm_FormLink__LKpwT","InputCapsule":"LoginForm_InputCapsule__wHAwj"};